@if (isVisible) {
  <div class="modal-backdrop" (click)="close()">
    <div class="about-dialog" (click)="$event.stopPropagation()">
      <h3 class="text-bosch-h3 font-bosch-strong text-bosch-gray-900 mb-bosch-md">About</h3>
      <p class="text-sm text-bosch-gray-700 mb-bosch-sm"><strong>Version:</strong> {{ version }}</p>
      <p class="text-sm text-bosch-gray-700 mb-bosch-lg"><strong>Released:</strong> {{ compiledTimestamp }}</p>
      <!-- Recent Updates Section -->
      @if (notifications.length > 0) {
        <div class="notifications-section mb-bosch-lg">
          <h4 class="text-bosch-h4 font-bosch-strong text-bosch-gray-900 mb-bosch-sm">Recent Updates:</h4>
          @for (notification of notifications; track notification) {
            <div class="notification-item">
              <h5 class="notification-headline">{{ notification.headline }}</h5>
              <div class="notification-content">{{ notification.content }}</div>
            </div>
          }
        </div>
      }
      <button class="bg-bosch-blue-500 hover:bg-bosch-blue-600 text-white font-bosch-medium py-bosch-sm px-bosch-md rounded-bosch-md border-2 border-bosch-blue-700 hover:border-bosch-blue-800 transition-all duration-200 text-center text-sm w-full" (click)="close()">Close</button>
    </div>
  </div>
}